import React from 'react';
import styles from './index.module.less';
import { FormattedMessage } from 'react-intl';
import Icon1 from './icon1.png';
import Icon2 from './icon2.png';
import Icon3 from './icon3.png';
import Icon4 from './icon4.png';
const imgList: any[] = [Icon1, Icon2, Icon3, Icon4];
const iconList: any[] = [
  {
    title: 'Home.Manage.Item1.Title',
    desc: 'Home.Manage.Item1.Description',
    url: 'https://account.xiaomi.com',
  },
  {
    title: 'Home.Manage.Item2.Title',
    desc: 'Home.Manage.Item2.Description',
    url: 'https://i.mi.com',
  },
  {
    title: 'Home.Manage.Item3.Title',
    desc: 'Home.Manage.Item3.Description',
    url: 'https://account.xiaomi.com/fe/service/account/privacy',
  },
  {
    title: 'Home.Manage.Item4.Title',
    desc: 'Home.Manage.Item4.Description',
    url: 'https://account.xiaomi.com/pass/del',
  },
];
const LinkTo = (url: string) => {
  window.open(url);
};

const Url: React.FC = () => (
  <div className={styles.wrapper}>
    <div className={styles.title}>
      <FormattedMessage id='Home.Manage.Title' />
    </div>
    <div className={styles.cardWrapper}>
      {iconList.map((item, index) => {
        return (
          <div
            key={index}
            className={styles.card}
            onClick={() => LinkTo(item.url)}
          >
            <img className={styles.img} src={imgList[index]} alt='' />
            <div className={styles.textWrapper}>
              <div className={styles.itemTitle}>
                <FormattedMessage id={item.title} />
              </div>
              <div className={styles.itemDesc}>
                <FormattedMessage id={item.desc} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default Url;
